<template lang='pug'>
//- Side-Effect-Consult
div(:class='$style[`cc-side-effect-consult`]')
  div(v-if='openChatRoom' :class='$style[`cc-side-effect-consult-wrap`]')
    EffectChatRoom(
    :indexOverview='false'
    :showProfile='false'
    :activated='true'
    :startLoad='true')
  div(v-else :class='$style[`cc-side-effect-consult-wrap`]')
    EffectConsultVendor

  //- div(v-if='rwdType == `desktop`' :class='$style[`cc-side-effect-consult-wrap`]')
  //-   EffectChatRoom(v-if='openChatRoom && $route.query.v')
  //-   EffectConsultVendor(v-else)

  //- div(v-else :class='[$style[`cc-side-effect-consult-wrap`], $style[openChatRoom ? `slide-to-right` : ``]]')
  //-   EffectChatRoom(v-if='openChatRoom && $route.query.v')
  //-   EffectConsultVendor(v-else)

</template>

<script>
import { mapMutations } from 'vuex';
import EffectChatRoom from './EffectChatRoom';
import EffectConsultVendor from './EffectConsultVendor';

// import { mixin as clickaway } from 'vue-clickaway';
// import { debounce } from 'debounce';

// import {
//   putChatConsultRoomList,
// } from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: '線上諮詢',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/sideeffect/consult',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/sideeffect/consult',
      }],
    };
  },

  components: {
    EffectChatRoom,
    EffectConsultVendor,
  },

  created() {
    if (this.$route.query.v) {
      this.openChatRoom = true;
    }
  },

  // beforeDestroy() {
  //   if (document.body.classList.contains('cc-overflow-hide')) {
  //     document.body.classList.remove('cc-overflow-hide');
  //   }
  // },

  data() {
    return {
      openChatRoom: false,
      consultRooms: [],
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      updateChatRemind: 'user/USER_UPDATE_CHAT_REMIND',
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
      // changeUpdateKey: 'global/FORCE_UPDATE_KEY',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //     rwdType: 'global/exportRwdType',
  //     // loginDjangoId: 'user/exportUserDjangoId',
  //     // loginStatus: 'user/exportLoginStatus',
  //     // loginProfile: 'user/exportUserProfile',
  //     // authJwtToken: 'user/exportUserJwtToken',
  //     // subscribeVip: 'user/exportUserSubscribeVip',
  //     // loginHashCode: 'user/exportUserHashCode',
  //   }),
  // },

  watch: {
    $route(to, from) {
      console.log('route', this.$route);
      if (to.name === 'effect-consult' && this.$route.query.v) {
        this.openChatRoom = true;
      } else {
        this.openChatRoom = false;
      }
    },
    // sendMsg() {
    //   this.detectRoomTyping();
    // },

    // rwdType() {
    //   this.initRoomWebsocket();
    // },
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectConsult.scss';
</style>
